import ErrorWrapper from './ErrorWrapper';

export default ErrorWrapper;
